export const today = () => new Date().toISOString().split('T')[0]!;

export const daysSince = (d?: string | null) =>
  d ? Math.floor((Date.now() - new Date(d).getTime()) / 86_400_000) : 999;

export const fmtDate = (d?: string | null) =>
  d ? new Date(d).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' }) : '—';

export const fmtRelativeDays = (n: number): string => {
  if (n === 0) return 'today';
  if (n === 1) return '1 day';
  return `${n} days`;
};

export const fmtILS = (v?: number | string | null) => {
  if (v === undefined || v === null || v === '') return '—';
  const n = typeof v === 'number' ? v : Number(v);
  if (!Number.isFinite(n) || n === 0) return '—';
  return `₪${Math.round(n).toLocaleString()}`;
};

export const isOverdue = (date?: string | null) =>
  !!date && new Date(date) < new Date(today());

export const STALE_DAYS = 7;

/**
 * Normalize an Israeli phone number into "+972…" form. Input examples:
 *   050-123-4567   → +972501234567
 *   0501234567     → +972501234567
 *   +972 50 123 4567 → +972501234567
 * Returns null if the number can't be normalized.
 */
export const normalizeILPhone = (raw?: string | null): string | null => {
  if (!raw) return null;
  const digits = raw.replace(/[^\d+]/g, '');
  if (digits.startsWith('+')) return digits.replace(/[^\d+]/g, '');
  if (digits.startsWith('00')) return '+' + digits.slice(2);
  if (digits.startsWith('0')) return '+972' + digits.slice(1);
  if (digits.startsWith('972')) return '+' + digits;
  return digits.length >= 9 ? '+972' + digits : null;
};

export const telHref = (raw?: string | null) => {
  const n = normalizeILPhone(raw);
  return n ? `tel:${n}` : null;
};

export const whatsappHref = (raw?: string | null, prefilled?: string) => {
  const n = normalizeILPhone(raw);
  if (!n) return null;
  const base = `https://wa.me/${n.replace(/^\+/, '')}`;
  return prefilled ? `${base}?text=${encodeURIComponent(prefilled)}` : base;
};
